const enMessages = {
  'checkout-closed': 'Checkout is closed',
  'header.program-test-mode': 'Program is in test mode. Payment card won\'t be charged.',
  'header.buy-a-gift': 'Buy a {businessName} gift',
  'header.checkout': 'Checkout',
  'header.billing-details': 'Confirm your order details and enter your billing information',
  'header.to': 'Gift Recipient',
  'header.from': 'Gift Sender',
  'header.amount': 'Amount',
  'header.balance': 'Balance',
  'header.gift-amount': 'Gift amount',
  'header.delivery': 'Delivery',
  'header.deliver-now': 'Send gift now to {giftRecipient}',
  'header.deliver-future': 'Send gift on {deliverOn} to {giftRecipient}',
  'header.message': 'Message',
  'header.discount': 'Discount',
  'header.select-business': 'Select an establishment',
  'header.select-business-template': 'Select a {merchantLabel}',
  'header.step-gift': 'Your Gift',
  'header.step-delivery': 'Delivery',
  'header.step-payment': 'Payment',
  'header.add-promo-code': 'Add promo code',
  'header.order-summary': 'Order Summary',
  'header.locations': 'Locations',
  'header.amount-to-add-to-card': 'Amount to add to card',
  'form.recipient': 'Recipient',
  'form.recipient-name': 'Recipient name',
  'form.recipient-email': 'Recipient email',
  'form.sender-name': 'Sender name',
  'form.message': 'Message',
  'form.amount': 'Amount',
  'form.custom-amount': 'Custom amount',
  'form.incentive': 'Add {amount} or more, receive a {bonusPercentage}% bonus.',
  'form.select-business': 'Establishment',
  'form.delivery': 'Send gift',
  'form.now': 'Now',
  'form.later': 'Later',
  'form.delivery-date': 'Delivery date',
  'form.delivery-time': 'Delivery time',
  'form.email-to-recipient': 'Email to Recipient',
  'form.email-to-you': 'Email to You',
  'form.gift-card-number': 'Gift card number',
  'button.continue': 'Continue',
  'button.pay': 'Pay {amount}',
  'button.processing': 'Completing order...',
  'button.back': 'Go Back',
  'button.buy-another-card': 'Send another gift card',
  'button.done': 'Done',
  'button.select-business': 'Select an establishment',
  'button.select-business-template': 'Select a {merchantLabel}',
  'button.custom-amount': 'Custom',
  'button.cancel': 'Cancel',
  'button.apply': 'Apply',
  'button.send-instantly': 'Send Instantly',
  'button.send-later': 'Send on a future date',
  'button.edit': 'Edit',
  'button.view-locations': 'View Locations',
  'button.add-to-cart': 'Add to Cart',
  'button.new-card-action': 'Buy a gift card',
  'button.reload-card-action': 'Reload card',
  'button.check-balance': 'Check balance',
  'pay.test-card-header': 'You can use this test card',
  'pay.card': 'Card',
  'pay.expiration': 'Expiration',
  'pay.cvc': 'CVC',
  'pay.zip': 'Zip',
  'pay.card-details': 'Card details',
  'pay.card-holder-name': 'Cardholder name',
  'placeholder.sender-name': 'Your name',
  'placeholder.sender-email': 'Your email',
  'placeholder.recipient-name': 'Recipient name',
  'placeholder.recipient-email': 'Recipient email',
  'placeholder.message': 'Make it personal',
  'placeholder.promo-code': 'Enter a promo code',
  'placeholder.card-holder-name': 'Cardholder name',
  'placeholder.first-name': 'First name',
  'placeholder.last-name': 'Last name',
  'placeholder.billing-address-street1': 'Address line 1',
  'placeholder.billing-address-street2': 'Address line 2',
  'placeholder.billing-address-city': 'City',
  'placeholder.billing-address-postalcode': 'Postal code',
  'placeholder.billing-address-zipcode': 'ZIP code',
  'placeholder.billing-address-country': 'Country',
  'placeholder.billing-address-state': 'State',
  'placeholder.billing-address-region': 'Region',
  'placeholder.gift-card-number': 'Gift card number',
  'label.purchaser-email': 'Sender email',
  'label.or': 'or',
  'label.balance': 'BALANCE',
  'label.gift': 'Gift',
  'label.promo-code': 'Promo code',
  'label.send-to-sender': 'I want to send this to myself.',
  'label.use-payment-card': 'Use payment card',
  'label.card-holder': 'Card Holder Name',
  'label.card-number': 'Card Number',
  'label.card-expiry': 'Expiration',
  'label.card-cvc': 'CVV',
  'label.card-zip': 'Postal code',
  'label.card-street-address': 'Street Address',
  'label.card-details': 'Card Details',
  'label.powered-by': 'Powered by',
  'label.terms': 'Terms',
  'label.privacy': 'Privacy',
  'label.deliver-instantly': 'Deliver Now',
  'label.deliver-on': 'Deliver on',
  'label.billing-details': 'Billing Details',
  'label.billing-address': 'Billing Address',
  'label.state': 'State',
  'label.province': 'Province',
  'label.region': 'Region',
  'label.select-region': 'Select Region',
  'label.select-state': 'Select State',
  'label.select-province': 'Select Province',
  'label.gift-card-balance': 'Card balance',
  'label.amount-you-pay': 'Amount you pay',
  'label.gift-amount': 'Gift amount',
  'label.bonus-gift-card': 'Bonus gift card',
  'label.bonus-amount': 'Bonus amount',
  'label.reload-new-balance': 'Your new balance will be {newBalance}',
  'confirmation.title-order-complete': 'Order Complete',
  'confirmation.title-order-received': 'Order Received',
  'confirmation.description-order-complete-gift-sent': 'Your {giftAmount} gift card was sent to {recipientEmail}.',
  'confirmation.description-order-received-gift-sent': 'Your {giftAmount} gift card will be sent to {recipientEmail} once we process your order.',
  'confirmation.description-order-complete-gift-send-later': 'Your {giftAmount} gift card will be sent to {recipientEmail} on {deliveryDate} at {deliveryTime}.',
  'confirmation.description-order-complete-confirmation': 'A receipt was sent to {senderEmail}',
  'confirmation.description-order-received-confirmation': 'A receipt will be sent to {senderEmail}',
  'confirmation.description-reload-order-complete': '{reloadAmount} was added to your gift card.',
  'confirmation.description-reload-order-received': '{reloadAmount} will be added to your gift card once we process your order.',
  'confirmation.description-reload-order-complete-confirmation': 'Your card\'s new balance is {newBalance}.',
  'confirmation.description-reload-order-received-confirmation': 'Your card\'s new balance will be {newBalance}.',
  'error.program-not-found': 'The merchant has not completed the setup of the checkout. No card program has been created yet.',
  'error.program-not-active': 'The merchant has disabled the checkout. Card program is not active.',
  'error.no-card-design': 'The merchant has not completed the setup of the checkout. No card design has been created yet.',
  'error.no-payment-gateway': 'The merchant has not completed the setup of the checkout. No payment gateway has been connected yet.',
  'error.checkout-disabled': 'Checkout has been disabled.',
  'error.unknown': 'An unexpected error has occurred.',
  'error.email-required': 'Email is required.',
  'error.email-not-valid': 'Not a valid email.',
  'error.name-required': 'Name is required.',
  'error.card-number-required': 'Card number is required.',
  'error.card-expiry-required': 'Card expiry is required.',
  'error.card-cvc-required': 'Card CVC is required.',
  'error.card-zip-required': 'Zip is required.',
  'error.amount-greater-than-zero': 'Amount must be greater than 0.',
  'error.program-required': 'Select a specific establishment.',
  'error.deliver-date-required': 'Deliver date is required.',
  'error.billing-first-name-required': 'First name required.',
  'error.billing-last-name-required': 'Last name required.',
  'error.billing-street1-required': 'Address street required.',
  'error.billing-city-required': 'City required.',
  'error.billing-postalcode-required': 'Postal code required.',
  'error.billing-country-required': 'Country required.',
  'error.billing-state-required': 'State required.',
  'error.gift-card-number-required': 'Gift card number required.',
};

const frMessages = {
  'checkout-closed': 'La caisse est fermée',
  'header.program-test-mode': 'Le programme est en mode test. La carte de paiement ne sera pas débitée.',
  'header.buy-a-gift': 'Acheter un cadeau {businessName}',
  'header.checkout': 'Paiement',
  'header.billing-details': 'Confirmez les détails de votre commande et entrez vos informations de facturation',
  'header.to': 'Destinataire du cadeau',
  'header.from': 'Expéditeur du Cadeau',
  'header.amount': 'Montant',
  'header.balance': 'Solde',
  'header.gift-amount': 'Montant du cadeau',
  'header.delivery': 'Livraison',
  'header.deliver-now': 'Envoyer cadeau maintenant',
  'header.deliver-future': 'Votre cadeau sera envoyé {deliverOn}',
  'header.message': 'Message',
  'header.discount': 'Remise',
  'header.select-business': 'Sélectionnez un établissement',
  'header.select-business-template': 'Sélectionnez un {merchantLabel}',
  'header.step-gift': 'Votre cadeau',
  'header.step-delivery': 'Livraison',
  'header.step-payment': 'Paiement',
  'header.add-promo-code': 'Ajouter un code promo',
  'header.order-summary': 'Récapitulatif de la commande',
  'header.locations': 'Emplacements',
  'header.amount-to-add-to-card': 'Montant à ajouter à la carte',
  'form.recipient': 'Destinataire',
  'form.recipient-name': 'Nom du destinataire',
  'form.recipient-email': 'Email du destinataire',
  'form.sender-name': 'Nom de l\'expéditeur',
  'form.message': 'Message',
  'form.amount': 'Montant',
  'form.custom-amount': 'Montant personnalisé',
  'form.incentive': 'Ajoutez {amount} ou plus, recevez un bonus de {bonusPercentage}%.',
  'form.select-business': 'Établissement',
  'form.delivery': 'Date d\'envoi',
  'form.now': 'À présent',
  'form.later': 'Plus tard',
  'form.delivery-date': 'Choississez votre date d\'envoi',
  'form.delivery-time': 'Choississez votre temps d\'envoi',
  'form.email-to-recipient': 'Email au Destinataire',
  'form.email-to-you': 'Email à Vous',
  'form.gift-card-number': 'Numéro de la carte-cadeau',
  'button.continue': 'Continuer',
  'button.pay': 'Payer {amount}',
  'button.processing': 'Terminer la commande...',
  'button.back': 'Retour',
  'button.buy-another-card': 'Envoyer une autre carte-cadeau',
  'button.done': 'Terminé',
  'button.select-business': 'Sélectionnez un établissement',
  'button.select-business-template': 'Sélectionnez un {merchantLabel}',
  'button.custom-amount': 'Personnalisé',
  'button.cancel': 'Annuler',
  'button.apply': 'Appliquer',
  'button.send-instantly': 'Envoyer instantanément',
  'button.send-later': 'Envoyer à une date ultérieure',
  'button.edit': 'Éditer',
  'button.view-locations': 'Voir les emplacements',
  'button.add-to-cart': 'Ajouter au Panier',
  'button.new-card-action': 'Acheter une carte cadeau',
  'button.reload-card-action': 'Recharger la carte',
  'button.check-balance': 'Vérifier le solde',
  'pay.test-card-header': 'Vous pouvez utiliser cette carte de test',
  'pay.card': 'Carte',
  'pay.expiration': 'Expiration',
  'pay.cvc': 'CVC',
  'pay.zip': 'Code postal',
  'pay.card-details': 'Détails de la carte',
  'label.purchaser-email': 'Email de l\'expéditeur',
  'placeholder.sender-name': 'Votre nom',
  'placeholder.sender-email': 'Votre email',
  'placeholder.recipient-name': 'Nom du destinataire',
  'placeholder.recipient-email': 'Email du destinataire',
  'placeholder.message': 'Personnalisez',
  'placeholder.promo-code': 'Entrez un code promo',
  'placeholder.card-holder-name': 'Nom du titulaire',
  'placeholder.first-name': 'Prénom',
  'placeholder.last-name': 'Nom de famille',
  'placeholder.billing-address-street1': 'Adresse Ligne 1',
  'placeholder.billing-address-street2': 'Adresse Ligne 2',
  'placeholder.billing-address-city': 'Ville',
  'placeholder.billing-address-postalcode': 'Code Postal',
  'placeholder.billing-address-zipcode': 'Code Postal',
  'placeholder.billing-address-country': 'Pays',
  'placeholder.billing-address-state': 'État',
  'placeholder.billing-address-region': 'Région',
  'pay.card-holder-name': 'Nom du titulaire',
  'label.or': 'ou',
  'label.balance': 'SOLDE',
  'label.gift': 'Cadeau',
  'label.use-payment-card': 'Utiliser une carte de paiement',
  'label.promo-code': 'Code promo',
  'label.send-to-sender': 'Je veux m\'envoyer ça.',
  'label.card-holder': 'Nom du titulaire',
  'label.card-number': 'Numéro de carte',
  'label.card-expiry': 'Expiration',
  'label.card-cvc': 'CVV',
  'label.card-zip': 'Code Postal',
  'label.card-street-address': 'Adresse de la rue',
  'label.card-details': 'Détails de la carte',
  'label.powered-by': 'Alimenté par',
  'label.terms': 'Conditions',
  'label.privacy': 'Confidentialité',
  'label.deliver-instantly': 'Livrer maintenant',
  'label.deliver-on': 'Livrer le',
  'label.billing-details': 'Détails de la facturation',
  'label.billing-address': 'Adresse de facturation',
  'label.state': 'Etat',
  'label.province': 'Province',
  'label.region': 'Région',
  'label.select-region': 'Choisissez une Région',
  'label.select-state': 'Choisissez une Etat',
  'label.select-province': 'Choisissez une Province',
  'label.gift-card-balance': 'Solde de la carte',
  'label.amount-you-pay': 'Montant que vous payez',
  'label.gift-amount': 'Montant du cadeau',
  'label.bonus-gift-card': 'Carte-cadeau en prime',
  'label.bonus-amount': 'Montant du bonus',
  'label.reload-new-balance': 'Votre nouveau solde sera de {newBalance}',
  'confirmation.title-order-complete': 'Ordre terminée',
  'confirmation.title-order-received': 'Ordre reçu',
  'confirmation.description-order-complete-gift-sent': 'Votre carte-cadeau de {giftAmount} a été envoyée à {recipientEmail}',
  'confirmation.description-order-received-gift-sent': 'Votre carte-cadeau de {giftAmount} sera envoyée à {recipientEmail} une fois que nous aurons traité votre commande.',
  'confirmation.description-order-complete-gift-send-later': 'Votre carte-cadeau de {giftAmount} sera envoyée à {recipientEmail} le {deliveryDate} à {deliveryTime}.',
  'confirmation.description-order-complete-confirmation': 'Un reçu a été envoyé à {senderEmail}',
  'confirmation.description-order-received-confirmation': 'Un reçu sera envoyé à {senderEmail}',
  'confirmation.description-reload-order-complete': '{reloadAmount} a été ajouté à votre carte-cadeau.',
  'confirmation.description-reload-order-received': '{reloadAmount} sera ajouté à votre carte-cadeau une fois que nous aurons traité votre commande.',
  'confirmation.description-reload-order-complete-confirmation': 'Le nouveau solde de votre carte est de {newBalance}.',
  'confirmation.description-reload-order-received-confirmation': 'Le nouveau solde de votre carte sera de {newBalance}.',
  'error.program-not-found': 'Le marchand n\'a pas terminé la configuration de la caisse. Aucun programme de carte n\'a encore été créé.',
  'error.program-not-active': 'Le marchand a désactivé la caisse. Le programme de carte n\'est pas actif.',
  'error.no-card-design': 'Le marchand n\'a pas terminé la configuration de la caisse. Aucune conception de carte n\'a encore été créée.',
  'error.no-payment-gateway': 'Le marchand n\'a pas terminé la configuration de la caisse. Aucune passerelle de paiement n\'a encore été connectée.',
  'error.checkout-disabled': 'La caisse a été désactivé.',
  'error.unknown': 'Une erreur imprévue s\'est produite.',
  'error.email-required': 'Email est requis.',
  'error.email-not-valid': 'Pas un email valide.',
  'error.name-required': 'Le nom est requis.',
  'error.card-number-required': 'Le numéro de carte est requis.',
  'error.card-expiry-required': 'La date d\'expiration de la carte est obligatoire.',
  'error.card-cvc-required': 'La carte CVC est requise.',
  'error.card-zip-required': 'Code postal est requis.',
  'error.amount-greater-than-zero': 'Le montant doit être supérieur à 0.',
  'error.program-required': 'Sélectionnez un établissement spécifique.',
  'error.deliver-date-required': 'La date de livraison est requise.',
  'error.gift-card-number-required': 'Numéro de carte-cadeau requis.',
};

const deMessages = {
  'checkout-closed': 'Kasse ist geschlossen',
  'header.program-test-mode': 'Programm befindet sich im Testmodus. Zahlungskarte wird nicht belastet.',
  'header.buy-a-gift': 'Kaufe ein Geschenk von {businessName}',
  'header.checkout': 'Zur Kasse',
  'header.billing-details': 'Bestätigen Sie Ihre Bestelldetails und geben Sie Ihre Rechnungsinformationen ein',
  'header.to': 'Geschenkempfänger',
  'header.from': 'Geschenkabsender',
  'header.amount': 'Betrag',
  'header.balance': 'Guthaben',
  'header.gift-amount': 'Geschenkbetrag',
  'header.delivery': 'Lieferung',
  'header.deliver-now': 'Geschenk jetzt an {giftRecipient} senden',
  'header.deliver-future': 'Geschenk am {deliverOn} an {giftRecipient} senden',
  'header.message': 'Nachricht',
  'header.discount': 'Rabatt',
  'header.select-business': 'Einen Betrieb auswählen',
  'header.select-business-template': 'Wählen Sie ein {merchantLabel}',
  'header.step-gift': 'Dein Geschenk',
  'header.step-delivery': 'Lieferung',
  'header.step-payment': 'Zahlung',
  'header.add-promo-code': 'Promo-Code hinzufügen',
  'header.order-summary': 'Zusammenfassung der Bestellung',
  'header.locations': 'Standorte',
  'header.amount-to-add-to-card': 'Betrag, der der Karte hinzugefügt werden soll',
  'form.recipient': 'Empfänger',
  'form.recipient-name': 'Name des Empfängers',
  'form.recipient-email': 'Empfänger-E-Mail',
  'form.sender-name': 'Absendername',
  'form.message': 'Nachricht',
  'form.betrag': 'Betrag',
  'form.custom-amount': 'Benutzerdefinierter Betrag',
  'form.incentive': 'Fügen Sie {amount} oder mehr hinzu, erhalten Sie einen Bonus von {bonusPercentage} %.',
  'form.select-business': 'Einrichtung',
  'form.delivery': 'Geschenk senden',
  'form.now': 'Jetzt',
  'form.später': 'Später',
  'form.delivery-date': 'Lieferdatum',
  'form.delivery-time': 'Lieferzeit',
  'form.email-to-recipient': 'E-Mail an Empfänger',
  'form.email-to-you': 'E-Mail an Sie',
  'form.gift-card-number': 'Geschenkkartennummer',
  'button.continue': 'Weiter',
  'button.pay': 'Zahle {amount}',
  'button.processing': 'Bestellung abschließen...',
  'button.back': 'Zurück',
  'button.buy-another-card': 'Weitere Geschenkkarte versenden',
  'button.done': 'Fertig',
  'button.select-business': 'Einen Betrieb auswählen',
  'button.select-business-template': 'Wählen Sie ein {merchantLabel}',
  'button.custom-amount': 'Benutzerdefiniert',
  'button.cancel': 'Abbrechen',
  'button.apply': 'Übernehmen',
  'button.send-instantly': 'Sofort senden',
  'button.send-later': 'An einem zukünftigen Datum senden',
  'button.edit': 'Bearbeiten',
  'button.view-locations': 'Standorte anzeigen',
  'button.add-to-cart': 'Zum Warenkorb hinzufügen',
  'button.new-card-action': 'Kaufen Sie eine Geschenkkarte',
  'button.reload-card-action': 'Karte neu laden',
  'button.check-balance': 'Kontostand prüfen',
  'pay.test-card-header': 'Sie können diese Testkarte verwenden',
  'pay.card': 'Karte',
  'pay.expiration': 'Ablauf',
  'pay.cvc': 'CVC',
  'pay.zip': 'Zip',
  'pay.card-details': 'Kartendetails',
  'pay.card-holder-name': 'Name des Karteninhabers',
  'placeholder.sender-name': 'Ihr Name',
  'placeholder.sender-email': 'Ihre E-Mail',
  'placeholder.recipient-name': 'Name des Empfängers',
  'placeholder.recipient-email': 'Empfänger-E-Mail',
  'placeholder.message': 'Personalisieren',
  'placeholder.promo-code': 'Geben Sie einen Aktionscode ein',
  'placeholder.card-holder-name': 'Name des Karteninhabers',
  'placeholder.first-name': 'Vorname',
  'placeholder.last-name': 'Nachname',
  'placeholder.billing-address-street1': 'Adresszeile 1',
  'placeholder.billing-address-street2': 'Adresszeile 2',
  'placeholder.billing-address-city': 'Stadt',
  'placeholder.billing-address-postalcode': 'Postleitzahl',
  'placeholder.billing-address-zipcode': 'Postleitzahl',
  'placeholder.billing-address-country': 'Land',
  'placeholder.billing-address-state': 'Bundesland',
  'placeholder.billing-address-region': 'Region',
  'label.purchaser-email': 'Absender-E-Mail',
  'label.or': 'oder',
  'label.balance': 'Kartenguthaben',
  'label.gift': 'Geschenk',
  'label.promo-code': 'Promo-Code',
  'label.send-to-sender': 'Ich möchte dies an mich selbst senden.',
  'label.use-payment-card': 'Zahlungskarte verwenden',
  'label.card-number': 'Kartennummer',
  'label.card-expiry': 'Ablauf',
  'label.card-cvc': 'CVV',
  'label.card-zip': 'Postleitzahl',
  'label.card-details': 'Kartendetails',
  'label.powered-by': 'Unterstützt von',
  'label.terms': 'Bedingungen',
  'label.privacy': 'Datenschutz',
  'label.deliver-instantly': 'Jetzt liefern',
  'label.deliver-on': 'Liefern Sie weiter',
  'label.billing-details': 'Rechnungsdetails',
  'label.billing-address': 'Rechnungsadresse',
  'label.state': 'Bundesland',
  'label.province': 'Provinz',
  'label.region': 'Region',
  'label.select-region': 'Region auswählen',
  'label.select-state': 'Bundesland auswählen',
  'label.select-province': 'Provinz auswählen',
  'label.gift-card-balance': 'Kartenguthaben',
  'label.amount-you-pay': 'Betrag, den Sie zahlen',
  'label.gift-amount': 'Geschenkbetrag',
  'label.bonus-gift-card': 'Bonus-Geschenkkarte',
  'label.bonus-amount': 'Bonusbetrag',
  'label.reload-new-balance': 'Ihr neues Gleichgewicht wird sein {newBalance}',
  'confirmation.title-order-complete': 'Bestellung abgeschlossen',
  'confirmation.title-order-received': 'Bestellung erhalten',
  'confirmation.description-order-complete-gift-sent': 'Ihr {giftAmount} Geschenkgutschein wurde an {recipientEmail} gesendet.',
  'confirmation.description-order-received-gift-sent': 'Ihr {giftAmount} Geschenkgutschein wird an {recipientEmail} gesendet, sobald wir Ihre Bestellung bearbeitet haben.',
  'confirmation.description-order-complete-gift-send-later': 'Ihr {giftAmount} Geschenkgutschein wird am {deliveryDate} um {deliveryTime} an {recipientEmail} gesendet.',
  'confirmation.description-order-complete-confirmation': 'Eine Quittung wurde an {senderEmail} gesendet',
  'confirmation.description-order-received-confirmation': 'Eine Quittung wird an {senderEmail} gesendet',
  'confirmation.description-reload-order-complete': '{reloadAmount} wurde Ihrer Geschenkkarte hinzugefügt.',
  'confirmation.description-reload-order-received': '{reloadAmount} wird Ihrer Geschenkkarte hinzugefügt, sobald wir Ihre Bestellung bearbeitet haben.',
  'confirmation.description-reload-order-complete-confirmation': 'Das neue Guthaben Ihrer Karte beträgt {newBalance}.',
  'confirmation.description-reload-order-received-confirmation': 'Das neue Guthaben Ihrer Karte beträgt {newBalance}.',
  'error.program-not-found': 'Der Händler hat die Einrichtung der Kasse nicht abgeschlossen. Es wurde noch kein Kartenprogramm erstellt.',
  'error.program-not-active': 'Der Händler hat die Kasse deaktiviert. Kartenprogramm ist nicht aktiv.',
  'error.no-card-design': 'Der Händler hat die Einrichtung der Kasse nicht abgeschlossen. Es wurde noch kein Kartendesign erstellt.',
  'error.no-payment-gateway': 'Der Händler hat die Einrichtung des Checkouts nicht abgeschlossen. Es wurde noch kein Zahlungsgateway verbunden.',
  'error.checkout-disabled': 'Checkout wurde deaktiviert.',
  'error.unknown': 'Ein unerwarteter Fehler ist aufgetreten.',
  'error.email-required': 'E-Mail ist erforderlich.',
  'error.email-not-valid': 'Keine gültige E-Mail.',
  'error.name-required': 'Name ist erforderlich.',
  'error.card-number-required': 'Kartennummer ist erforderlich.',
  'error.card-expiry-required': 'Kartenablauf ist erforderlich.',
  'error.card-cvc-required': 'Karten-CVC ist erforderlich.',
  'error.card-zip-required': 'Zip ist erforderlich.',
  'error.amount-greater-than-zero': 'Betrag muss größer als 0 sein.',
  'error.program-required': 'Wählen Sie eine bestimmte Einrichtung aus.',
  'error.deliver-date-required': 'Lieferdatum ist erforderlich.',
  'error.billing-first-name-required': 'Vorname erforderlich.',
  'error.billing-last-name-required': 'Nachname erforderlich.',
  'error.billing-street1-required': 'Adresse Straße erforderlich.',
  'error.billing-city-required': 'Stadt erforderlich.',
  'error.billing-postalcode-required': 'Postleitzahl erforderlich.',
  'error.billing-country-required': 'Land erforderlich.',
  'error.billing-state-required': 'Bundesland erforderlich.',
  'error.gift-card-number-required': 'Geschenkkartennummer erforderlich.',
};

const itMessages = {
  'checkout-closed': 'Il checkout è chiuso',
  'header.program-test-mode': 'Il programma è in modalità test. La carta di pagamento non verrà addebitata.',
  'header.buy-a-gift': 'Acquista un regalo per {businessName}',
  'header.checkout': 'Acquista',
  'header.billing-details': 'Conferma i dettagli dell\'ordine e inserisci i tuoi dati di fatturazione',
  'header.to': 'Destinatario regalo',
  'header.from': 'Mittente regalo',
  'header.amount': 'Importo',
  'header.balance': 'Saldo',
  'header.gift-amount': 'Importo regalo',
  'header.delivery': 'Consegna',
  'header.deliver-now': 'Invia regalo ora a {giftRecipient}',
  'header.deliver-future': 'Invia regalo il giorno {deliverOn} a {giftRecipient}',
  'header.message': 'Messaggio',
  'header.discount': 'Sconto',
  'header.select-business': 'Seleziona una struttura',
  'header.select-business-template': 'Seleziona un {merchantLabel}',
  'header.step-gift': 'Il tuo regalo',
  'header.step-delivery': 'Consegna',
  'header.step-payment': 'Pagamento',
  'header.add-promo-code': 'Aggiungi codice promozionale',
  'header.order-summary': 'Riepilogo ordine',
  'header.amount-to-add-to-card': 'Importo da aggiungere alla carta',
  'header.locations': 'Posizioni',
  'form.recipient': 'Destinatario',
  'form.recipient-name': 'Nome destinatario',
  'form.recipient-email': 'Email destinatario',
  'form.sender-name': 'Nome mittente',
  'form.message': 'Messaggio',
  'form.amount': 'Importo',
  'form.custom-amount': 'Importo personalizzato',
  'form.incentive': 'Aggiungi {amount} o più, ricevi un bonus del {bonusPercentage}%.',
  'form.select-business': 'Stabilimento',
  'form.delivery': 'Invia regalo',
  'form.now': 'Adesso',
  'form.later': 'Più tardi',
  'form.delivery-date': 'Data di consegna',
  'form.delivery-time': 'Tempi di consegna',
  'form.email-to-recipient': 'Email al destinatario',
  'form.email-to-you': 'Email a te',
  'form.gift-card-number': 'Numero della carta regalo',
  'button.continue': 'Continua',
  'button.pay': 'Paga {amount}',
  'button.processing': 'Completamento ordine...',
  'button.back': 'Torna indietro',
  'button.buy-another-card': 'Invia un\'altra carta regalo',
  'button.done': 'Fatto',
  'button.select-business': 'Seleziona una struttura',
  'button.select-business-template': 'Seleziona un {merchantLabel}',
  'button.custom-amount': 'Personalizzato',
  'button.cancel': 'Annulla',
  'button.apply': 'Applica',
  'button.send-instantly': 'Invia istantaneamente',
  'button.send-later': 'Invia in una data futura',
  'button.edit': 'Modifica',
  'button.view-locations': 'Visualizza località',
  'button.add-to-cart': 'Aggiungi al carrello',
  'button.new-card-action': 'Acquista una carta regalo',
  'button.reload-card-action': 'Ricarica carta',
  'button.check-balance': 'Controlla il saldo',
  'pay.test-card-header': 'Puoi utilizzare questa carta di prova',
  'pay.card': 'Carta',
  'pay.expiration': 'Scadenza',
  'pay.cvc': 'CVC',
  'pay.zip': 'Zip',
  'pay.card-details': 'Dettagli carta',
  'pay.card-holder-name': 'Nome del titolare della carta',
  'placeholder.sender-name': 'Il tuo nome',
  'placeholder.sender-email': 'La tua email',
  'placeholder.recipient-name': 'Nome destinatario',
  'placeholder.recipient-email': 'Email destinatario',
  'placeholder.message': 'Rendilo personale',
  'placeholder.promo-code': 'Inserisci un codice promozionale',
  'placeholder.card-holder-name': 'Nome del titolare della carta',
  'placeholder.first-name': 'Nome',
  'placeholder.last-name': 'Cognome',
  'placeholder.billing-address-street1': 'Riga indirizzo 1',
  'placeholder.billing-address-street2': 'Riga indirizzo 2',
  'placeholder.billing-address-city': 'Città',
  'placeholder.billing-address-postalcode': 'Codice postale',
  'placeholder.billing-address-zipcode': 'codice postale',
  'placeholder.billing-address-country': 'Paese',
  'placeholder.billing-address-state': 'Stato',
  'placeholder.billing-address-region': 'Regione',
  'label.purchaser-email': 'Email del mittente',
  'label.or': 'o',
  'label.balance': 'SALDO',
  'label.gift': 'Regalo',
  'label.promo-code': 'Codice promozionale',
  'label.send-to-sender': 'Voglio inviarlo a me stesso.',
  'label.use-payment-card': 'Utilizza carta di pagamento',
  'label.card-number': 'Numero carta',
  'label.card-expiry': 'Scadenza',
  'label.card-cvc': 'CVV',
  'label.card-zip': 'Codice postale',
  'label.card-details': 'Dettagli carta',
  'label.powered-by': 'Alimentato da',
  'label.terms': 'Termini',
  'label.privacy': 'Privacy',
  'label.deliver-instantly': 'Consegna ora',
  'label.deliver-on': 'Consegna',
  'label.billing-details': 'Dettagli di fatturazione',
  'label.billing-address': 'Indirizzo di fatturazione',
  'label.state': 'Stato',
  'label.province': 'Provincia',
  'label.region': 'Regione',
  'label.select-region': 'Seleziona regione',
  'label.select-state': 'Seleziona stato',
  'label.select-province': 'Seleziona provincia',
  'label.gift-card-balance': 'Saldo della carta',
  'label.amount-you-pay': 'Importo che paghi',
  'label.gift-amount': 'Importo regalo',
  'label.bonus-gift-card': 'Buono regalo',
  'label.bonus-amount': 'Importo del bonus',
  'label.reload-new-balance': 'Il tuo nuovo equilibrio sarà {newBalance}',
  'confirmation.title-order-complete': 'Ordine completato',
  'confirmation.title-order-received': 'Ordine ricevuto',
  'confirmation.description-order-complete-gift-sent': 'La tua carta regalo {giftAmount} è stata inviata a {recipientEmail}.',
  'confirmation.description-order-received-gift-sent': 'La tua carta regalo {giftAmount} verrà inviata a {recipientEmail} una volta elaborato il tuo ordine.',
  'confirmation.description-order-complete-gift-send-later': 'La tua carta regalo {giftAmount} verrà inviata a {recipientEmail} il {deliveryDate} alle {deliveryTime}.',
  'confirmation.description-order-complete-confirmation': 'È stata inviata una ricevuta a {senderEmail}',
  'confirmation.description-order-received-confirmation': 'Verrà inviata una ricevuta a {senderEmail}',
  'confirmation.description-reload-order-complete': '{reloadAmount} è stato aggiunto alla tua carta regalo.',
  'confirmation.description-reload-order-received': '{reloadAmount} verrà aggiunto alla tua carta regalo una volta elaborato il tuo ordine.',
  'confirmation.description-reload-order-complete-confirmation': 'Il nuovo saldo della tua carta è {newBalance}.',
  'confirmation.description-reload-order-received-confirmation': 'Il nuovo saldo della tua carta sarà {newBalance}.',
  'error.program-not-found': 'Il commerciante non ha completato la configurazione del checkout. Non è stato ancora creato alcun programma per carte.',
  'error.program-not-active': 'Il commerciante ha disabilitato il checkout. Il programma della carta non è attivo.',
  'error.no-card-design': 'Il commerciante non ha completato la configurazione del checkout. Non è stato ancora creato alcun design di carta.',
  'error.no-payment-gateway': 'Il commerciante non ha completato la configurazione del checkout. Nessun gateway di pagamento è stato ancora connesso.',
  'error.checkout-disabled': 'Il pagamento è stato disabilitato.',
  'error.unknown': 'Si è verificato un errore imprevisto.',
  'error.email-required': 'L\'email è obbligatoria.',
  'error.email-not-valid': 'Email non valida.',
  'error.name-required': 'Il nome è obbligatorio.',
  'error.card-number-required': 'Il numero della carta è obbligatorio.',
  'error.card-expiry-required': 'La scadenza della carta è obbligatoria.',
  'error.card-cvc-required': 'Il CVC della carta è obbligatorio.',
  'error.card-zip-required': 'Lo zip è obbligatorio.',
  'error.amount-greater-than-zero': 'L\'importo deve essere maggiore di 0.',
  'error.program-required': 'Seleziona una struttura specifica.',
  'error.deliver-date-required': 'La data di consegna è obbligatoria.',
  'error.billing-first-name-required': 'Nome richiesto.',
  'error.billing-last-name-required': 'Cognome richiesto.',
  'error.billing-street1-required': 'Indirizzo via richiesto.',
  'error.billing-city-required': 'Città richiesta.',
  'error.billing-postalcode-required': 'Codice postale richiesto.',
  'error.billing-country-required': 'Paese richiesto.',
  'error.billing-state-required': 'Stato richiesto.',
  'error.gift-card-number-required': 'Numero della carta regalo richiesto.',
};

const esMessages = {
  'checkout-closed': 'La caja está cerrada',
  'header.program-test-mode': 'El programa está en modo de prueba. No se cargará la tarjeta de pago.',
  'header.buy-a-gift': 'Comprar un regalo de {businessName}',
  'header.checkout': 'Pagar',
  'header.billing-details': 'Confirma los detalles de tu pedido e ingresa tu información de facturación',
  'header.to': 'Destinatario del regalo',
  'header.from': 'Remitente del regalo',
  'header.quantity': 'Cantidad',
  'header.balance': 'Saldo',
  'header.gift-amount': 'Cantidad del regalo',
  'header.delivery': 'Entrega',
  'header.deliver-now': 'Enviar regalo ahora a {giftRecipient}',
  'header.deliver-future': 'Enviar regalo en {deliverOn} a {giftRecipient}',
  'header.message': 'Mensaje',
  'header.discount': 'Descuento',
  'header.select-business': 'Seleccione un establecimiento',
  'header.select-business-template': 'Seleccione un {merchantLabel}',
  'header.step-gift': 'Tu regalo',
  'header.step-delivery': 'Entrega',
  'header.step-pay': 'Pago',
  'header.add-promo-code': 'Agregar código de promoción',
  'header.order-summary': 'Resumen del pedido',
  'header.amount-to-add-to-card': 'Cantidad a agregar a la tarjeta',
  'header.locations': 'Ubicaciones',
  'form.recipient': 'Destinatario',
  'form.recipient-name': 'Nombre del destinatario',
  'form.recipient-email': 'Correo electrónico del destinatario',
  'form.sender-name': 'Nombre del remitente',
  'form.message': 'Mensaje',
  'form.quantity': 'Cantidad',
  'form.custom-amount': 'Cantidad personalizada',
  'form.incentive': 'Agregue {amount} o más, reciba un {bonusPercentage}% de bonificación.',
  'form.select-business': 'Establecimiento',
  'form.delivery': 'Enviar regalo',
  'form.now': 'Ahora',
  'form.later': 'Más tarde',
  'form.delivery-date': 'Fecha de entrega',
  'form.delivery-time': 'Tiempo de entrega',
  'form.email-to-recipient': 'Correo electrónico al destinatario',
  'form.email-to-you': 'Correo electrónico para usted',
  'form.gift-card-number': 'Numero de tarjeta de regalo',
  'button.continue': 'Continuar',
  'button.pay': 'Pagar {amount}',
  'button.processing': 'Completando pedido...',
  'button.back': 'Volver',
  'button.buy-another-card': 'Enviar otra tarjeta de regalo',
  'button.done': 'Listo',
  'button.select-business': 'Seleccione un establecimiento',
  'button.select-business-template': 'Seleccione un {merchantLabel}',
  'button.custom-amount': 'Personalizado',
  'button.cancel': 'Cancelar',
  'button.apply': 'Aplicar',
  'button.send-instantly': 'Enviar al instante',
  'button.send-later': 'Enviar en una fecha futura',
  'button.edit': 'Editar',
  'button.view-locations': 'Ver Ubicaciones',
  'button.add-to-cart': 'Agregar al carrito',
  'button.new-card-action': 'Comprar una tarjeta de regalo',
  'button.reload-card-action': 'Recargar tarjeta',
  'button.check-balance': 'Consultar saldo',
  'pay.test-card-header': 'Puedes usar esta tarjeta de prueba',
  'pay.card': 'Tarjeta',
  'pay.expiration': 'Caducidad',
  'pay.cvc': 'CVC',
  'pay.zip': 'Código postal',
  'pay.card-details': 'Detalles de la tarjeta',
  'pay.card-holder-name': 'Nombre del titular de la tarjeta',
  'placeholder.sender-name': 'Tu nombre',
  'placeholder.sender-email': 'Tu correo electrónico',
  'placeholder.recipient-name': 'Nombre del destinatario',
  'placeholder.recipient-email': 'Correo electrónico del destinatario',
  'placeholder.message': 'Hazlo personal',
  'placeholder.promo-code': 'Ingrese un código de promoción',
  'placeholder.card-holder-name': 'Nombre del titular de la tarjeta',
  'placeholder.first-name': 'Nombre',
  'placeholder.last-name': 'Apellido',
  'placeholder.billing-address-street1': 'Línea de dirección 1',
  'placeholder.billing-address-street2': 'Dirección línea 2',
  'placeholder.billing-address-city': 'Ciudad',
  'placeholder.billing-address-postalcode': 'Código postal',
  'placeholder.billing-address-zipcode': 'Código postal',
  'placeholder.billing-address-country': 'País',
  'placeholder.billing-address-state': 'Estado',
  'placeholder.billing-address-region': 'Región',
  'label.purchaser-email': 'Correo electrónico del remitente',
  'label.or': 'o',
  'label.balance': 'SALDO',
  'label.gift': 'Regalo',
  'label.promo-code': 'Código promocional',
  'label.send-to-sender': 'Quiero enviarme esto a mí mismo.',
  'label.use-payment-card': 'Usar tarjeta de pago',
  'label.card-number': 'Número de tarjeta',
  'label.card-expiry': 'Caducidad',
  'label.card-cvc': 'CVV',
  'label.card-zip': 'Código postal',
  'label.card-details': 'Detalles de la tarjeta',
  'label.powered-by': 'Desarrollado por',
  'label.terms': 'Términos',
  'label.privacy': 'Privacidad',
  'label.deliver-instantly': 'Entregar ahora',
  'label.deliver-on': 'Entregar en',
  'label.billing-details': 'Detalles de facturación',
  'label.billing-address': 'Dirección de facturación',
  'label.state': 'Estado',
  'label.province': 'Provincia',
  'label.region': 'Región',
  'label.select-region': 'Seleccionar región',
  'label.select-state': 'Seleccionar Estado',
  'label.select-province': 'Seleccionar provincia',
  'label.gift-card-balance': 'Balance de tarjeta',
  'label.amount-you-pay': 'Cantidad que paga',
  'label.gift-amount': 'Cantidad de regalo',
  'label.bonus-gift-card': 'Tarjeta de regalo de bonificación',
  'label.bonus-amount': 'Monto del bono',
  'label.reload-new-balance': 'Su nuevo saldo será {newBalance}',
  'confirmation.title-order-complete': 'Pedido completo',
  'confirmation.title-order-received': 'Pedido recibido',
  'confirmation.description-order-complete-gift-sent': 'Su tarjeta de regalo {giftAmount} fue enviada a {recipientEmail}.',
  'confirmation.description-order-received-gift-sent': 'Su tarjeta de regalo de {giftAmount} se enviará a {recipientEmail} una vez que procesemos su pedido.',
  'confirmation.description-order-complete-gift-send-later': 'Su tarjeta de regalo de {giftAmount} se enviará a {recipientEmail} el {deliveryDate} a las {deliveryTime}.',
  'confirmation.description-order-complete-confirmation': 'Se envió un recibo a {senderEmail}',
  'confirmation.description-order-received-confirmation': 'Se enviará un recibo a {senderEmail}',
  'confirmation.description-reload-order-complete': 'Se agregó {reloadAmount} a su tarjeta de regalo.',
  'confirmation.description-reload-order-received': '{reloadAmount} se agregará a su tarjeta de regalo una vez que procesemos su pedido.',
  'confirmation.description-reload-order-complete-confirmation': 'El nuevo saldo de su tarjeta es {newBalance}.',
  'confirmation.description-reload-order-received-confirmation': 'El nuevo saldo de su tarjeta será {newBalance}.',
  'error.program-not-found': 'El comerciante no ha completado la configuración del pago. Aún no se ha creado ningún programa de tarjeta.',
  'error.program-not-active': 'El comerciante ha deshabilitado el pago. El programa de la tarjeta no está activo.',
  'error.no-card-design': 'El comerciante no ha completado la configuración del pago. Aún no se ha creado ningún diseño de tarjeta.',
  'error.no-payment-gateway': 'El comerciante no ha completado la configuración del pago. Aún no se ha conectado ninguna pasarela de pago.',
  'error.checkout-disabled': 'El pago ha sido deshabilitado.',
  'error.unknown': 'Ha ocurrido un error inesperado.',
  'error.email-required': 'Se requiere correo electrónico.',
  'error.email-not-valid': 'No es un correo electrónico válido.',
  'error.name-required': 'Se requiere el nombre.',
  'error.card-number-required': 'Se requiere el número de tarjeta.',
  'error.card-expiry-required': 'Se requiere el vencimiento de la tarjeta.',
  'error.card-cvc-required': 'Se requiere tarjeta CVC.',
  'error.card-zip-required': 'Se requiere código postal.',
  'error.amount-greater-than-zero': 'La cantidad debe ser mayor que 0.',
  'error.program-required': 'Seleccione un establecimiento específico.',
  'error.deliver-date-required': 'Se requiere la fecha de entrega.',
  'error.billing-first-name-required': 'Se requiere el primer nombre.',
  'error.billing-last-name-required': 'Apellido requerido.',
  'error.billing-street1-required': 'Dirección calle requerida.',
  'error.billing-city-required': 'Ciudad requerida.',
  'error.billing-postalcode-required': 'Código postal requerido.',
  'error.billing-country-required': 'País requerido.',
  'error.billing-state-required': 'Estado requerido.',
  'error.gift-card-number-required': 'Número de tarjeta de regalo requerido.',
};

const messages = {
  'en-US': enMessages,
  'en-CA': enMessages,
  'en-GB': enMessages,
  'en-IE': enMessages,
  'en-AU': enMessages,
  'fr-FR': frMessages,
  'fr-CA': frMessages,
  'de-DE': deMessages,
  'it-IT': itMessages,
  'es-ES': esMessages,
};

export default messages;
